import { Component, OnInit, ViewChild } from '@angular/core'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AddChildProfileComponent } from '@se-po/shared-ui-add-child-profile'
import { SeFeFormService } from 'se-fe-form-service'

import { ChildInfoSubmitter } from './child-info-submit.service'

@Component({
  selector: 'se-po-household-setup-feature-child-info',
  templateUrl: './child-info.component.html',
  styleUrls: ['./child-info.component.scss'],
})
export class ChildInfoComponent implements OnInit {
  @ViewChild('childInfo') public childInfo: AddChildProfileComponent
  public ready = false

  constructor(
    public setupBarService: SetupBarService,
    public store: StoreService,
    public submitter: ChildInfoSubmitter,
    private formService: SeFeFormService,
  ) { }

  public ngOnInit(): void {
    this.ready = true
    this.setupBarService.percentComplete = 15
  }

  public submit(): void {
    if (!this.formService.isValid(this.childInfo.form)) return

    this.submitter.submit(this.childInfo.value, this.store)
  }
}
